import { createValidation, createSchema } from '../../utils/validator';

export const contactFormSchema = (t) =>
  createSchema({
    name: createValidation().required(t('error.fieldRequired')),
    email: createValidation().required(t('error.fieldRequired')).email(t('error.emailIncorrect')),
    reason: createValidation().exist(t('error.fieldRequired')),
    message: createValidation().required(t('error.fieldRequired')),
  });
